import { useMultiCurrencyStorage } from '@/features/hotels/hooks/useHotelMultiCurrencyStorage';
import { cn } from '@/lib/utils';
import { useCurrencyStore } from '@/store/useCurrencyStore';
import { CurrencyAssetType, CurrencyHelper } from '@/utils/CurrencyHelper';
import { NumbersHelper } from '@/utils/numbersHelper';
import { FC } from 'react';

type Props = {
    value?: number | string;
    asset?: CurrencyAssetType;
    addStyles?: boolean;
};

const CurrencyValue: FC<Props> = ({ value, asset, addStyles }) => {
    const { currentCurrency } = useCurrencyStore();
    const { multiCurrency, currencies } = useMultiCurrencyStorage();

    const { sign, colorClass } = NumbersHelper.formatValueConfig(Number(value));

    const currency = multiCurrency ? currentCurrency : currencies;

    const roundedValue = typeof value === 'number' ? (value ?? 0).toFixed(2) : '0.00';

    return  (
        <span className={cn(addStyles && colorClass)}>
            {`${addStyles ? sign : ''}${roundedValue} ${CurrencyHelper.syncCurrency(asset, multiCurrency, currency)}`}
        </span>
    );    
    ;
};

export default CurrencyValue;
